import { z } from 'zod'
import { mapDTOToMoney, mapMoneyToDTO, MoneyDTO } from '@cplug/frontend-core'
import type { StoreFulfillmentSetting } from '../../models/AppSetting'

export const StoreFulfillmentSettingDTOSchema = z.object({
  fulfillments_available: z.array(z.string()),
  min_pickup_time: z.number().nullish(),
  min_pickup_order_value: MoneyDTO,
  min_delivery_order_value: MoneyDTO,
  free_delivery_fee_from_order_value: MoneyDTO
})

export type StoreFulfillmentSettingDTO = z.infer<typeof StoreFulfillmentSettingDTOSchema>

function normalizePickupMinutes (value: number | null | undefined): number {
  if (value == null || Number.isNaN(value)) {
    return 0
  }

  return value
}

export function mapDTOToStoreFulfillmentSetting (dto: StoreFulfillmentSettingDTO): StoreFulfillmentSetting {
  return {
    fulfillmentsAvailable: dto.fulfillments_available,
    minPickupMinutes: normalizePickupMinutes(dto.min_pickup_time),
    minPickupOrderValue: mapDTOToMoney(dto.min_pickup_order_value),
    minDeliveryOrderValue: mapDTOToMoney(dto.min_delivery_order_value),
    freeDeliveryFeeFromOrder: mapDTOToMoney(dto.free_delivery_fee_from_order_value)
  }
}

export function mapStoreFulfillmentSettingToDTO (model: StoreFulfillmentSetting): StoreFulfillmentSettingDTO {
  return {
    fulfillments_available: model.fulfillmentsAvailable,
    min_pickup_time: normalizePickupMinutes(model.minPickupMinutes),
    min_pickup_order_value: mapMoneyToDTO(model.minPickupOrderValue),
    min_delivery_order_value: mapMoneyToDTO(model.minDeliveryOrderValue),
    free_delivery_fee_from_order_value: mapMoneyToDTO(model.freeDeliveryFeeFromOrder)
  }
}
